import React, { useState, useEffect } from "react";
import BreadCrumbBanner from "../component/BreadCrumbBanner";
import aboutAPI from "../api/aboutApi";

const OurPhilosophy = () => {
  const [philosphy, setPhilosphy] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOurPhilosphy = async () => {
      try {
        const response = await aboutAPI.our_philosphy();
        if (response.code === 200) {
          setPhilosphy(response.data["our-philosophy"][0]);
        }
      } catch (error) {
        console.error("Error fetching Our Philosphy :", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOurPhilosphy();
  }, []);
  return (
    <>
      {/* BreadCrump Section */}
      <BreadCrumbBanner
        title="Our Philosophy"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      {/* philosphy section */}
      <section className="philo-intro-section">
        <div className="container">
          <div className="philo-intro-wrap text-center">
            <span className="mrv-subtitle">{philosphy?.type}</span>
            <h2 className="mrv-title">{philosphy?.title}</h2>
            <p className="philo-description">{philosphy?.short_description}</p>
          </div>
        </div>
      </section>

      {/* learning beyond classroom */}
      <section className="philo-story-section bg-light">
        <div className="container">
          <div className="row align-items-center g-5">
            {/* LEFT : CONTENT */}
            <div className="col-lg-6">
              <div className="philo-story-content">
                 <div
                    dangerouslySetInnerHTML={{
                      __html: philosphy?.description,
                    }}
                  />
               
              </div>
            </div>
            {/* RIGHT : IMAGE */}
            <div className="col-lg-6">
              <div className="philo-story-image">
                <img
                  src={philosphy?.image}
                  alt="School Learning"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* commitment section */}
      <section className="philo-closing-section">
        <div className="container">
          <div className="philo-closing-wrap text-center">
            <h2 className="philo-closing-title">
              Our Commitment to Every Learner
            </h2>
            <p className="philo-closing-text">
              We are committed to nurturing confident thinkers, compassionate
              individuals, and responsible citizens. Our philosophy empowers
              students to explore their potential, embrace challenges, and lead
              the future with knowledge and integrity.
            </p>
            {/* belief points */}
            <div className="philo-closing-points">
              <span>Inspire Curiosity</span>
              <span>Build Character</span>
              <span>Encourage Innovation</span>
              <span>Empower Leadership</span>
            </div>
          </div>
        </div>
      </section>

      {/* pillars */}
      <section className="philo-belief-section">
        <div className="container">
          <div className="row g-4">
            {philosphy?.listings?.map((item) => (
              <div className="col-lg-3 col-md-6" key={item.id}>
                <div className="philo-belief-card">
                  <h5>{item.listingtitle}</h5>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.listingdescription,
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default OurPhilosophy;
